import { useEffect } from "react";
import { data, useFetcher } from "react-router";

import { userPrefs } from "./utils/cookies.server";
import { SWR } from "~/.server/caching.server";
import { getClient } from "~/contentful/contentful.server";

import type { TypeCookieContentSkeleton } from "~/contentful/compiled";
import { COOKIE_BANNER } from "~/contentful/contents";
import { useURL } from "~/contexts";

export const loader = async ({ request, context }: LoaderArgs) => {
  const url = new URL(request.url);
  const preview = url.searchParams.get("preview");
  const client = getClient(!!preview);
  const [swrCookie] = SWR.stable("cookie-data", [
    "cookie",
    "data",
    "contentful",
  ]);
  const isBot = context.isbot;
  const cookieData = await swrCookie(async () => {
    return await client.getEntry<TypeCookieContentSkeleton>(COOKIE_BANNER);
  }, []);

  const cookieHeader = request.headers.get("Cookie");
  const cookie = (await userPrefs.parse(cookieHeader)) || {};
  const showCookieBanner = isBot
    ? false
    : typeof cookie.showBanner === "undefined"
      ? true
      : cookie.showBanner;

  return data(
    {
      showCookieBanner,
      cookieData,
    },
    {
      headers: {
        "Cache-Control": "private, max-age=0, no-cache",
      },
    },
  );
};

export const action = async ({ request }: ActionArgs) => {
  const cookieHeader = request.headers.get("Cookie");
  const cookie = (await userPrefs.parse(cookieHeader)) || {};
  const bodyParams = await request.formData();
  cookie.showBanner = bodyParams.get("bannerVisibility") === "visible";

  return data(
    {},
    {
      headers: {
        "Set-Cookie": await userPrefs.serialize(cookie),
      },
    },
  );
};

export const useCookieBanner = () => {
  const fetcher = useFetcher<typeof loader>();
  const url = useURL();
  useEffect(() => {
    if (fetcher.state === "idle" && !fetcher.data) {
      fetcher.load(url(`/resources/cookie`));
    }
  }, [url, fetcher]);
  return fetcher.data;
};
